/**
 * Created by michielknevels on 12/10/17.
 */
import React from 'react';
import icons from './icons.json';

const MobIcon = (props) => <i style={props.style} className={`ic-${props.name} icon-${icons[props.name]}`} />;

export default MobIcon;
